export const getUserImg = () => {
    return "https://static.vecteezy.com/system/resources/previews/021/059/827/original/chatgpt-logo-chat-gpt-icon-on-white-background-free-vector.jpg";
};

export const getMainHeader = () => {
  var header: string = "";
  header = "PrescribeFit Assistant";
  return (
    <div className="flex flex-col text-3xl text-white font-semibold text-center mt-6 sm:mt-[20vh] ml-auto mr-auto mb-10 sm:mb-16 items-end justify-center">
        <p className="font-bold">{header}</p>
    </div>
  );
};

export const getLoginHeader = () => {
  return (
      <div className="p-2 w-ful flex flex-col justify-center items-center">
        <img src="./big-logo.png" alt="PrescribeFit"></img>
        <h1 className="text-2xl font-bold text-[#6c7179]">ASSISTANT</h1>
      </div>
    );
};

export const getUserSuggestions = (): string[] => {
  return [
      "What Can CoachingApp Offer , and How ?",
    ];
};

export const getUserCapabilities = (): string[] => {
  return [
      "How does CoachingApp's software support medical calls management?",
    ];
};

export const getUserLimitations = (): string[] => {
  return [
      "Are there any integration limitations with CoachingApp's software?",
    ];

};
